import React, {useState, useContext, useEffect} from 'react';
import {Context} from '../../../context';
import {getTicketActiveStatus} from '../../../helperFunctions';

import FareProductTables from './FareProductTables';
import Section from '../../UI/Section';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

function CustomTabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{p: 3}}>{children}</Box>}
    </div>
  );
}

function a11yProps(name, subtext) {
  return {
    id: `simple-tab-${name}-${subtext}`,
    'aria-controls': `simple-tabpanel-${name}-${subtext}`
  };
}

const FareProductsSection = props => {
  const {selectedCard} = props;
  const {account, localeText} = useContext(Context);

  const [fareProductsAvailable, setFareProductsAvailable] = useState([]);
  const [fareProductsExpired, setFareProductsExpired] = useState([]);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (selectedCard?.uuid !== 'add') {
      let selectedCardTickets = account.transitAccounts[0].transitCards.find(
        ({uuid}) => uuid === selectedCard?.uuid
      )?.tickets;

      if (!selectedCardTickets) {
        selectedCardTickets = [];
      }

      setFareProductsAvailable(() => {
        return selectedCardTickets.filter(fareProduct => {
          const {ticketUnexpired} = getFareProductStatuses(fareProduct);
          return ticketUnexpired;
        });
      });

      setFareProductsExpired(() => {
        return selectedCardTickets.filter(fareProduct => {
          const {ticketUnexpired} = getFareProductStatuses(fareProduct);
          return !ticketUnexpired;
        });
      });
    }
  }, [selectedCard, account]);

  const getFareProductStatuses = fareProduct => {
    const ticketActiveStatus = getTicketActiveStatus(
      localeText,
      fareProduct.validFromDateTime,
      fareProduct.validToDateTime,
      fareProduct.sunsetDateTime
    );

    const ticketUnexpired =
      ticketActiveStatus === localeText('rw_title_expired', 'expired')
        ? false
        : true;

    return {ticketActiveStatus, ticketUnexpired};
  };

  return (
    <Section heading={localeText('rw_header_fare_products', 'Fare Products')}>
      <Box sx={{width: '100%'}}>
        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='basic tabs example'
          >
            <Tab
              label='Available'
              {...a11yProps('fare-products', 'available')}
            />
            <Tab label='Expired' {...a11yProps('fare-products', 'expired')} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <FareProductTables
            {...{fareProducts: fareProductsAvailable, getFareProductStatuses}}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <FareProductTables
            {...{fareProducts: fareProductsExpired, getFareProductStatuses}}
          />
        </CustomTabPanel>
      </Box>
    </Section>
  );
};

export default FareProductsSection;
